// extracted by mini-css-extract-plugin
module.exports = {"taxBlock":"TaxList_taxBlock__235Ep","taxBlockSelected":"TaxList_taxBlockSelected__dxk6f","taxBlockSpacing":"TaxList_taxBlockSpacing__1rMaT"};